import React, { useState } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { faArrowRight } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHistory } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';
import Button from '../../shared-components/buttons/Button';
import MainPage from '../../shared-components/main-page/MainPage';
import WhoAreWe from '../../../assets/images/who_are_we.jpg';
import './shared-components/home.css';
import VideoControl from './shared-components/VideoControl';

function Home() {
  const videoUrl = 'https://youtu.be/fOHS626D_G0';
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <MainPage>
      <div className="space-y-8">
        {/* Intro */}
        <div className="diagonal-bg">
          <a
            href="https://wa.me/17875313358?text=Hola%2C%20estoy%20interesado(a)"
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition duration-300"
            aria-label="Chat on WhatsApp"
          >
            <FaWhatsapp size={24} />
          </a>
          <div className="pt-8 px-4 lg:px-52 xl:px-72 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12">
            {/* First Row */}
            <div className="md:hidden flex col-span-1">
              <VideoControl url={videoUrl} />
            </div>
            <div className="col-span-1 lg:col-span-7 p-4">
              {/* <H1 className="text-center" text={t('main_page_title')} /> */}
              <div className="text-3xl md:text-4xl text-center font-bold">
                <span>{t('welcome_intro_1')}</span>
                <span> </span>
                <span className="text-primaryColor">{t('welcome_intro_2')}</span>
              </div>
              <div className="items-center mt-8 space-y-8">  
                <p className="text-2xl">
                  {t('intro_text')}
                </p>
                <p className="text-2xl">
                  {t('intro_text_2')}
                </p>
              </div>
            </div>
            <div className="hidden md:flex col-span-1 lg:col-span-5">
              <VideoControl className="py-12 my-auto" url={videoUrl} />
            </div>

            {/* Second Row */}
            <div className="col-span-1 lg:col-span-7 p-4">
              <div className="flex">
                <div className="hidden md:block bg-primaryColor" style={{ width: '15px' }} />
                <div className="text-4xl font-bold md:pl-8 md:pr-3 py-8">{t('prequalification_submit_cta')}</div>
                <div className="hidden md:block ml-auto my-auto">
                  <FontAwesomeIcon className="text-3xl text-primaryColor mr-4" icon={faArrowRight} />
                </div>
              </div>
            </div>
            <div className="col-span-1 lg:col-span-5 flex">
              <Button
                borderColor="border-secondaryBorderColor"
                text={t('prequalification')}
                className="m-auto w-2/3 h-16 bg-white text-xl text-secondaryTextColor hover:bg-primaryColor hover:border-primaryBorderColor hover:text-white"
                onClick={() => history.push('/lg/tps')}
              />
            </div>
          </div>
        </div>

        {/* Who Are we */}
        {/* <div className="text-center py-8 px-4 lg:px-52 xl:px-72 space-y-4">
          <div className="text-primaryColor font-bold">{t('who_we_are')}</div>
          <div className="text-4xl font-bold">{t('who_we_are_title')}</div>
          <div className="">{t('who_we_are_text')}</div>
          <img className="mx-auto rounded-3xl" src={WhoAreWe} alt={t('who_we_are')} />
        </div> */}
      </div>
    </MainPage>
  );
}

export default Home;
